export default __webpack_public_path__ + "static/media/NewsfeedActive.3c9f940f.svg";